import { render, staticRenderFns } from "./AddArticle.vue?vue&type=template&id=1b520a2a&scoped=true"
import script from "./AddArticle.vue?vue&type=script&lang=js"
export * from "./AddArticle.vue?vue&type=script&lang=js"
import style0 from "./AddArticle.vue?vue&type=style&index=0&id=1b520a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b520a2a",
  null
  
)

export default component.exports